import { c as _c } from "react/compiler-runtime";
import { useToggle } from '@onefootprint/hooks';
import { Button } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import PermissionGate from '@/components/permission-gate';
import type { FormData } from '@/pages/developers/vault-proxy/pages/list/vault-proxy.types';
import Dialog from '../../../../components/dialog';
const Create = () => {
  const $ = _c(20);
  const {
    t
  } = useTranslation("vault-proxy");
  const [isOpen, open, close] = useToggle(false);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      name: "",
      value: "",
      secret: false
    }];
    t1 = [{
      certificate: ""
    }];
    t2 = {
      certificate: "",
      key: ""
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      name: "",
      url: "",
      method: "POST",
      accessReason: "",
      headers: t0,
      pinnedServerCertificates: t1,
      clientIdentity: t2,
      ingressSettings: {
        contentType: "none",
        rules: []
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const defaultValues = t3;
  let t4;
  if ($[4] !== t) {
    t4 = t(_temp);
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t(_temp2);
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== open || $[9] !== t5) {
    t6 = <Button variant="primary" onClick={open}>{t5}</Button>;
    $[8] = open;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <PermissionGate scopeKind="manage_vault_proxy" fallbackText={t4}>{t6}</PermissionGate>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== close || $[15] !== isOpen) {
    t8 = <Dialog defaultValues={defaultValues} onClose={close} open={isOpen} />;
    $[14] = close;
    $[15] = isOpen;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default Create;
function _temp($) {
  return $.create.ctaNotAllowed;
}
function _temp2($_0) {
  return $_0.create.cta;
}